"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _utf8ByteLength = _interopRequireDefault(require("utf8-byte-length"));

/* eslint-disable */
var InstantPublish =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(InstantPublish, _Component);

  function InstantPublish(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "componentDidMount", function () {
      return _this.getLiveData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          location = _this$props.location;
      var _this$state = _this.state,
          stateProps = _this$state.props,
          currentPath = _this$state.currentPath;

      if (stateProps && stateProps.data && currentPath && currentPath === location.pathname) {
        return _react.default.cloneElement(children, stateProps);
      } else {
        return _react.default.cloneElement(children, _this.props);
      }
    });
    _this.state = {
      props: false,
      currentPath: false,
      debug: _this.props.debug || false
    };
    _this.getLiveData = _this.getLiveData.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.log = _this.log.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = InstantPublish.prototype;

  _proto.log = function log(data) {
    if (this.state.debug) console.log(data);
  };

  _proto.getLiveData =
  /*#__PURE__*/
  function () {
    var _getLiveData = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var _this$props$pageConte, wpUrl, latestBuildTime, id, currentPath, liveDataProps, restUrl, lastPublishUrl, liveDataUrl, storageName, sessionStorageString, latestPublishTime, sessionStorageJSON, liveData, _ref, limit, usedSpace, remSpace, jsonString, dataLength;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props$pageConte = this.props.pageContext, wpUrl = _this$props$pageConte.wpUrl, latestBuildTime = _this$props$pageConte.latestBuild, id = _this$props$pageConte.id;
              currentPath = this.props.location.pathname;
              liveDataProps = this.props;
              restUrl = wpUrl + "/wp-json/wordsby/v1";
              lastPublishUrl = restUrl + "/last_publish/" + id;
              liveDataUrl = restUrl + "/instant_publish_collections/" + id;
              this.log("You have instant publish debug mode enabled.");
              this.log("Fetching data from " + liveDataUrl + " and rehydrating the current page with live data.");
              storageName = "@@liveData|" + currentPath;
              sessionStorageString = sessionStorage.getItem(storageName);

              // check for local storage data and use it if it's there.
              if (sessionStorageString) {
                sessionStorageJSON = JSON.parse(sessionStorageString);
                liveDataProps.data.wordsbyCollections = sessionStorageJSON.data.wordsbyCollections;
                this.log("current props + localstorage data:");
                this.log(liveDataProps);
                this.setState({
                  props: liveDataProps,
                  currentPath: currentPath
                });
              } // get the latest publish time of the current page from WP


              _context.prev = 11;
              _context.next = 14;
              return fetch(lastPublishUrl);

            case 14:
              _context.next = 16;
              return _context.sent.json();

            case 16:
              latestPublishTime = _context.sent;
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](11);
              return _context.abrupt("return", console.warn(_context.t0));

            case 22:
              if (!(sessionStorageString && sessionStorageJSON.latestPublishTime === latestPublishTime && sessionStorageJSON.latestPublishTime > latestBuildTime && !this.state.debug)) {
                _context.next = 24;
                break;
              }

              return _context.abrupt("return");

            case 24:
              if (!(latestPublishTime < latestBuildTime && !this.state.debug)) {
                _context.next = 26;
                break;
              }

              return _context.abrupt("return", sessionStorageJSON ? sessionStorage.removeItem(storageName) && this.setState({
                props: this.props,
                currentPath: currentPath
              }) : false);

            case 26:
              _context.prev = 26;
              _context.next = 29;
              return fetch(liveDataUrl);

            case 29:
              _context.next = 31;
              return _context.sent.json();

            case 31:
              _ref = _context.sent;
              liveData = _ref[0];
              _context.next = 38;
              break;

            case 35:
              _context.prev = 35;
              _context.t1 = _context["catch"](26);
              return _context.abrupt("return", console.warn(_context.t1));

            case 38:
              this.log("live data response:");
              this.log(liveData);
              liveDataProps.data.wordsbyCollections = liveData; // set the updated props + current path so the page knows to update

              this.setState({
                props: liveDataProps,
                currentPath: currentPath
              }); // check remaining sessionstorage space

              limit = 1024 * 1024 * 5; // 5 MB

              usedSpace = unescape(encodeURIComponent(JSON.stringify(sessionStorage))).length;
              remSpace = limit - usedSpace;
              this.log("session storage bytes in use: " + usedSpace);
              this.log("remaining bytes available: " + remSpace); // get a string of our data.

              jsonString = JSON.stringify({
                data: {
                  wordsbyCollections: liveData
                },
                latestPublishTime: latestPublishTime
              });
              dataLength = (0, _utf8ByteLength.default)(jsonString); // if our string takes more storage than what's left, clear the storage

              if (dataLength > remSpace) sessionStorage.clear(); // store data in session storage so that reloads dont require more http requests.

              sessionStorage.setItem(storageName, jsonString);
              this.log("session data stored in key: " + storageName);

            case 52:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[11, 19], [26, 35]]);
    }));

    function getLiveData() {
      return _getLiveData.apply(this, arguments);
    }

    return getLiveData;
  }();

  _proto.componentDidUpdate = function componentDidUpdate(previousProps) {
    // only update if we're on a new page.
    // Sometimes the component does extra updates
    if (previousProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        props: false
      });
      this.getLiveData();
    }
  };

  return InstantPublish;
}(_react.Component);

var _default = InstantPublish;
exports.default = _default;